import React from "react";
import { useTranslation } from "react-i18next";
import ContentContainer from "../components/ContentContainer";
import ContributorCard from "../components/ContributorCard";
import "./Who.css";

function Who() {
  const { t } = useTranslation();
  const contributors = [
    {
      name: "Satochip",
      description: t("who.satochipDesc"),
      links: [
        { label: "Product", url: "https://satochip.io/product/satochip/" },
        { label: "Toporin GitHub", url: "https://github.com/Toporin" },
        { label: "Telegram", url: "https://t.me/Satochip" }
      ]
    },
    {
      name: "SeedSigner",
      description: t("who.seedsignerDesc"),
      links: [
        { label: "GitHub", url: "https://github.com/SeedSigner/seedsigner" }
      ]
    },
    {
      name: "3rd Iteration",
      description: t("who.thirdIterationDesc"),
      links: [
        { label: "GitHub", url: "https://github.com/3rdIteration/seedsigner" },
        { label: "YouTube", url: "https://www.youtube.com/@CryptoGuide" },
        { label: "Twitter", url: "https://x.com/YTCryptoGuide" },
        { label: "Donate", url: "https://cryptoguide.tips/send-me-a-tip/" }
      ]
    },
    {
      name: "BlueWallet",
      description: t("who.blueWalletDesc"),
      links: [
        { label: "Website", url: "https://bluewallet.io/" },
        { label: "GitHub", url: "https://github.com/BlueWallet/BlueWallet" }
      ]
    }
  ];

  return (
    <div className="who">
      <ContentContainer>
        <div className="contributors-section">
          <h2>{t("who.contributorsTitle")}</h2>
          <p className="contributors-tagline">{t("who.thanksDescription")}</p>
          <div className="contributors-grid">
            {contributors.map((contributor, index) => (
              <ContributorCard
                key={index}
                name={contributor.name}
                description={contributor.description}
                links={contributor.links}
              />
            ))}
          </div>
        </div>
      </ContentContainer>

      <ContentContainer>
        <div className="who-about-section">
          <div className="who-bio">
            <h3 className="who-name">{t("who.daniName")}</h3>
            <p className="who-description">{t("who.daniDescription")}</p>
            <div className="who-press-link">
              <a 
                href="https://bitcoinmagazine.com/business/building-your-own-hardware-wallet-seedsigner-and-satochip-combo-is-nuts"
                target="_blank"
                rel="noopener noreferrer"
                className="press-link"
              >
                {t("who.pressLink")} →
              </a>
            </div>
          </div>
        </div>
      </ContentContainer>
    </div>
  );
}

export default Who;

